import { ApplicationRef, ComponentRef, createComponent, ElementRef, EnvironmentInjector, Injectable } from '@angular/core';

import { TooltipComponent } from '../components/tooltip/tooltip.component';
import { ETooltipPlacement, ITooltipOptions } from '../components/tooltip/tooltip.types';
import { IPlacementDictionary, UtilService } from './util.service';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private tooltip!: ComponentRef<TooltipComponent>;
  private isTooltipActive: boolean = false;

  constructor(
    private _appRef: ApplicationRef,
    private _injector: EnvironmentInjector,
  ) { }

  public show(options: ITooltipOptions, baseElement: ElementRef) {
    if (this.isTooltipActive) {
      return;
    }

    const cordinates = baseElement.nativeElement.getBoundingClientRect();

    const tooltip = createComponent(TooltipComponent, {
      environmentInjector: this._injector,
    });

    this.tooltip = tooltip;

    for (const [key, value] of Object.entries(options)) {
      tooltip.setInput(key, value);
    }

    tooltip.setInput('positionX', cordinates.left);
    tooltip.setInput('positionY', cordinates.top);
    tooltip.setInput('containerWidth', cordinates.width);
    tooltip.setInput('containerHeight', cordinates.height);
    tooltip.setInput('tooltipWidth', options.width);

    setTimeout(() => {
      if (options.placement === ETooltipPlacement.AUTO) {
        const posDict = {
          top: ETooltipPlacement.TOP_CENTER,
          bottom: ETooltipPlacement.BOTTOM_CENTER,
          left: ETooltipPlacement.LEFT,
          right: ETooltipPlacement.RIGHT,
          topLeft: ETooltipPlacement.TOP_LEFT,
          default: ETooltipPlacement.TOP_CENTER,
        };

        const placement = UtilService.getAutoPlacement(baseElement, tooltip, posDict);
        tooltip.setInput('placement', placement);

        return;
      }

      tooltip.setInput('placement', options.placement);
    }, 0);

    document.body.appendChild(tooltip.location.nativeElement);
    this._appRef.attachView(tooltip.hostView);

    if (options.placement === ETooltipPlacement.AUTO) {
      setTimeout(() => {
        const posDictionary: IPlacementDictionary = {
          left: ETooltipPlacement.LEFT,
          right: ETooltipPlacement.RIGHT,
          top: ETooltipPlacement.TOP_CENTER,
          bottom: ETooltipPlacement.BOTTOM_CENTER,
          topLeft: ETooltipPlacement.TOP_LEFT,
          topRight: ETooltipPlacement.TOP_RIGHT,
          bottomLeft: ETooltipPlacement.BOTTOM_LEFT,
          bottomRight: ETooltipPlacement.BOTTOM_RIGHT,
          default: ETooltipPlacement.TOP_CENTER,
        };

        tooltip.setInput('placement', UtilService.getAutoPlacement(baseElement, this.tooltip, posDictionary));
      }, 0);
    }

    this.isTooltipActive = true;

  }

  public hide() {
    this.tooltip?.destroy();
    this.isTooltipActive = false;
  }
}
